import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instance1wzn9b23peown as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$default3mq4ssp61rg7w as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance23401jnwmesxf as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$("Buffer doesn't contain required number of bytes (size: " + $this.get_size_woubt6_k$().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.head_1 = null;
        this.tail_1 = null;
        this.sizeMut_1 = 0n;
      }
      get_size_woubt6_k$() {
        return this.sizeMut_1;
      }
      get_buffer_bmaafd_k$() {
        return this;
      }
      exhausted_p1jt55_k$() {
        return this.get_size_woubt6_k$() === 0n;
      }
      require_37jki9_k$(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        if (this.get_size_woubt6_k$() < byteCount) {
          throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$("Buffer doesn't contain required number of bytes (size: " + this.get_size_woubt6_k$().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      request_hj5jqj_k$(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        return this.get_size_woubt6_k$() >= byteCount;
      }
      readByte_ectjk2_k$() {
        var tmp0_elvis_lhs = this.head_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.get_size_woubt6_k$();
        if (segmentSize === 0) {
          this.recycleHead_e8xkbv_k$();
          return this.readByte_ectjk2_k$();
        }
        var v = segment.readByte_newmca_k$();
        this.sizeMut_1 = subtract(this.sizeMut_1, 1n);
        if (segmentSize === 1) {
          this.recycleHead_e8xkbv_k$();
        }
        return v;
      }
      readShort_ilpyey_k$() {
        var tmp0_elvis_lhs = this.head_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.get_size_woubt6_k$();
        if (segmentSize < 2) {
          this.require_37jki9_k$(2n);
          if (segmentSize === 0) {
            this.recycleHead_e8xkbv_k$();
            return this.readShort_ilpyey_k$();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.readByte_ectjk2_k$() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.readByte_ectjk2_k$() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.readShort_7b409e_k$();
        this.sizeMut_1 = subtract(this.sizeMut_1, 2n);
        if (segmentSize === 2) {
          this.recycleHead_e8xkbv_k$();
        }
        return v;
      }
      hintEmit_6b2e5m_k$() {
        return Unit_instance;
      }
      copyTo_xutsee_k$(out, startIndex, endIndex) {
        checkBounds(this.get_size_woubt6_k$(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.sizeMut_1 = add(out.sizeMut_1, remainingByteCount);
        var s = this.head_1;
        while (currentOffset >= fromInt(ensureNotNull(s).limit_1 - s.pos_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.limit_1 - s.pos_1 | 0));
          s = s.next_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).sharedCopy_efss0u_k$();
          copy.pos_1 = copy.pos_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.pos_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.limit_1;
          tmp.limit_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.head_1 == null) {
            out.head_1 = copy;
            out.tail_1 = copy;
          } else if (false) {
            out.tail_1 = ensureNotNull(out.tail_1).push_h69db4_k$(copy).compact_he236d_k$();
            if (ensureNotNull(out.tail_1).prev_1 == null) {
              out.head_1 = out.tail_1;
            }
          } else {
            out.tail_1 = ensureNotNull(out.tail_1).push_h69db4_k$(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.limit_1 - copy.pos_1 | 0));
          currentOffset = 0n;
          s = s.next_1;
        }
      }
      completeSegmentByteCount_46ltjp_k$() {
        var result = this.get_size_woubt6_k$();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.tail_1);
        if (tail.limit_1 < 8192 && tail.owner_1) {
          result = subtract(result, fromInt(tail.limit_1 - tail.pos_1 | 0));
        }
        return result;
      }
      get_f9lzxq_k$(position) {
        if (position < 0n || position >= this.get_size_woubt6_k$()) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('position (' + position.toString() + ') is not within the range [0..size(' + this.get_size_woubt6_k$().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.head_1).getUnchecked_g7gmig_k$(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.head_1 == null) {
            return ensureNotNull(null).getUnchecked_g7gmig_k$(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.get_size_woubt6_k$(), position) < position) {
            var s = this.tail_1;
            var offset = this.get_size_woubt6_k$();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.limit_1 - s.pos_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.prev_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).getUnchecked_g7gmig_k$(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.head_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.limit_1 - s_0.pos_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.next_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).getUnchecked_g7gmig_k$(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      clear_j9egeb_k$() {
        return this.skip_csbv9x_k$(this.get_size_woubt6_k$());
      }
      skip_csbv9x_k$(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.head_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.limit_1 - head.pos_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.sizeMut_1 = subtract(this.sizeMut_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.pos_1 = head.pos_1 + toSkip | 0;
          if (head.pos_1 === head.limit_1) {
            this.recycleHead_e8xkbv_k$();
          }
        }
      }
      readAtMostTo_kub29z_k$(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.head_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.get_size_woubt6_k$();
        var toCopy = Math.min(tmp0, b);
        s.readTo_7avxxz_k$(sink, startIndex, startIndex + toCopy | 0);
        this.sizeMut_1 = subtract(this.sizeMut_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.recycleHead_e8xkbv_k$();
        }
        return toCopy;
      }
      readAtMostTo_4oop6l_k$(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        if (this.get_size_woubt6_k$() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.get_size_woubt6_k$() ? this.get_size_woubt6_k$() : byteCount;
        sink.write_ob3ym3_k$(this, bytesWritten);
        return bytesWritten;
      }
      readTo_3vtbf7_k$(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        if (this.get_size_woubt6_k$() < byteCount) {
          sink.write_ob3ym3_k$(this, this.get_size_woubt6_k$());
          throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.get_size_woubt6_k$().toString() + ' bytes were written.');
        }
        sink.write_ob3ym3_k$(this, byteCount);
      }
      transferTo_lu4ka2_k$(sink) {
        var byteCount = this.get_size_woubt6_k$();
        if (byteCount > 0n) {
          sink.write_ob3ym3_k$(this, byteCount);
        }
        return byteCount;
      }
      peek_21nx7_k$() {
        return buffered(new (PeekSource())(this));
      }
      writableSegment_voqx71_k$(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        if (this.tail_1 == null) {
          var result = SegmentPool_instance.take_2451j_k$();
          this.head_1 = result;
          this.tail_1 = result;
          return result;
        }
        var t = ensureNotNull(this.tail_1);
        if ((t.limit_1 + minimumCapacity | 0) > 8192 || !t.owner_1) {
          var newTail = t.push_h69db4_k$(SegmentPool_instance.take_2451j_k$());
          this.tail_1 = newTail;
          return newTail;
        }
        return t;
      }
      write_ti570x_k$(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.writableSegment_voqx71_k$(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.get_remainingCapacity_c94947_k$();
          var toCopy = Math.min(tmp0, b);
          tail.write_j6nfmf_k$(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.sizeMut_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.sizeMut_1 = add(tmp0_0, fromInt(other));
      }
      write_9ocf0z_k$(source, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var read = source.readAtMostTo_4oop6l_k$(this, remainingByteCount);
          if (read === -1n) {
            throw EOFException().new_kotlinx_io_EOFException_1f8u0y_k$('Source exhausted before reading ' + byteCount.toString() + ' bytes. ' + ('Only ' + subtract(byteCount, remainingByteCount).toString() + ' were read.'));
          }
          remainingByteCount = subtract(remainingByteCount, read);
        }
      }
      write_ob3ym3_k$(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        checkOffsetAndCount(source.sizeMut_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.head_1).get_size_woubt6_k$())) {
            var tail = this.tail_1;
            var tmp;
            if (!(tail == null) && tail.owner_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.limit_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.get_shared_lt0222_k$() ? 0 : tail.pos_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.head_1).writeTo_vgyea0_k$(tail, convertToInt(remainingByteCount));
              source.sizeMut_1 = subtract(source.sizeMut_1, remainingByteCount);
              this.sizeMut_1 = add(this.sizeMut_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.head_1 = ensureNotNull(source.head_1).split_p6jwdi_k$(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.head_1);
          var movedByteCount = fromInt(segmentToMove.get_size_woubt6_k$());
          source.head_1 = segmentToMove.pop_417547_k$();
          if (source.head_1 == null) {
            source.tail_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.head_1 == null) {
            this.head_1 = segmentToMove;
            this.tail_1 = segmentToMove;
          } else if (true) {
            this.tail_1 = ensureNotNull(this.tail_1).push_h69db4_k$(segmentToMove).compact_he236d_k$();
            if (ensureNotNull(this.tail_1).prev_1 == null) {
              this.head_1 = this.tail_1;
            }
          } else {
            this.tail_1 = ensureNotNull(this.tail_1).push_h69db4_k$(segmentToMove);
          }
          source.sizeMut_1 = subtract(source.sizeMut_1, movedByteCount);
          this.sizeMut_1 = add(this.sizeMut_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      transferFrom_v29myr_k$(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.readAtMostTo_4oop6l_k$(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      writeByte_9ih3z3_k$(byte) {
        this.writableSegment_voqx71_k$(1).writeByte_naaedl_k$(byte);
        this.sizeMut_1 = add(this.sizeMut_1, 1n);
      }
      writeShort_vn2jsb_k$(short) {
        this.writableSegment_voqx71_k$(2).writeShort_n1l1d9_k$(short);
        this.sizeMut_1 = add(this.sizeMut_1, 2n);
      }
      close_yn9xrc_k$() {
        return Unit_instance;
      }
      toString() {
        if (this.get_size_woubt6_k$() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.get_size_woubt6_k$();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(imul(len, 2) + (this.get_size_woubt6_k$() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.head_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.get_size_woubt6_k$()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.getUnchecked_akrbjy_k$(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.append_58al37_k$(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.append_58al37_k$(tmp_1[tmp$ret$5]);
          }
          curr = curr.next_1;
        }
        if (this.get_size_woubt6_k$() > fromInt(maxPrintableBytes)) {
          builder.append_58al37_k$(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.get_size_woubt6_k$().toString() + ' hex=' + builder.toString() + ')';
      }
      recycleHead_e8xkbv_k$() {
        var oldHead = ensureNotNull(this.head_1);
        var nextHead = oldHead.next_1;
        this.head_1 = nextHead;
        if (nextHead == null) {
          this.tail_1 = null;
        } else {
          nextHead.prev_1 = null;
        }
        oldHead.next_1 = null;
        SegmentPool_instance.recycle_3mobff_k$(oldHead);
      }
      recycleTail_61sxi3_k$() {
        var oldTail = ensureNotNull(this.tail_1);
        var newTail = oldTail.prev_1;
        this.tail_1 = newTail;
        if (newTail == null) {
          this.head_1 = null;
        } else {
          newTail.next_1 = null;
        }
        oldTail.prev_1 = null;
        SegmentPool_instance.recycle_3mobff_k$(oldTail);
      }
    }
    protoOf($).write$default_fa5nq1_k$ = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
